<template>
    <div>
        <v-card class="soft-shadow px-3 py-1 mb-6">
            <v-card-text >
                <div class="d-flex justify-space-between">
                    <div class="pa-1">
                        <div class="mb-2 d-flex align-center">
                            <h2 class="strong-text--text font-weight-medium" style="line-height: 1">{{videoData.name}}</h2>
                            <div class="teachers ms-3 d-flex">

                            </div>
                        </div>
                        <div class="d-flex align-center">
                            <div class="me-3 text--text d-flex align-center">
                                <v-chip v-if="metaData && metaData.viewers" small style="height: 22px" class="green lighten-5 me-2 d-flex align-center">
                                    <v-icon color="success" size="15" class="me-1">mdi-account-multiple</v-icon>
                                    <transition name="scroll-y-transition" mode="out-in">
                                        <div :key="metaData.viewers" class="font-weight-bold success--text text--darken-1">{{metaData.viewers}}</div>
                                    </transition>
                                </v-chip>
                                <span v-if="videoData.views_limit">
                                    الحد اﻷقصى للمشاهدات: <b>{{videoData.views_limit}}</b>
                                </span>
                                <span v-else class="muted--text details-text">لا يوجد حد أقصى للمشاهدات</span>
                            </div>
                        </div>
                        <div class="d-flex mt-3">
                            <v-btn as="a" target="_blank" v-if="videoData.type === 'youtube'" small depressed color="red darken-1" dark :href="videoData.video_url">
                                <v-icon left>mdi-youtube</v-icon>
                                <span>فتح على يوتيوب</span>
                            </v-btn>
                            <v-btn as="a" target="_blank" v-else small depressed color="blue darken-2" dark :href="videoData.video_url">
                                <v-icon left>mdi-play-circle-outline</v-icon>
                                <span>فتح الفيديو</span>
                            </v-btn>
                        </div>
                    </div>
                    <div>
                        <v-btn :icon="phoneOnly" color="muted" text dense class="px-2" :to="lectureData ? `/lectures/${lectureData.id}` : '/'">
                            <span v-if="pcOnly">{{lectureData.name}}</span>
                            <v-icon :right="pcOnly">mdi-chevron-left</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-card-text>
        </v-card>

        <video-comments :video-data="videoData" :comments="comments" @sync-video="sync" @loadMoreComments="loadMore" />
        <video-views :page_url="page_url" :views="video_views" @loadMore="loadMore" />


        <!-- <action-dialog v-model="removeExamDialog" action="delete" :url="`/videos/${id}/exams/${removeExam ? removeExam.id : ''}`" title="إزالة الامتحان" button-text="تأكيد الحذف" button-color="error" @sync="removeExamItem(removeExam.id)">
            <div v-if="removeExam">
                <p class="strong-text--text mb-0">
                    هل أنت متأكد من إزالة الامتحان <b class="strong-text--text">"{{removeExam.name}}"</b> من المحاضرة؟
                </p>
            </div>
        </action-dialog> -->
    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'
import VideoViews from './VideoViews'
import VideoComments from './VideoComments'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        CrudTable,
        VideoViews,
        VideoComments
    },
    props: {
        video: {},
        meta: {},
        lecture: {},
        video_views: {},
        comments: {},
    },
    data() {
        return {
            videoData: null,
            metaData: null,

            interval: null,
            reloadingMeta: false,
        }
    },
    computed: {
        id(){
            return this.videoData.id;
        },
        page_url(){
            return '/videos/' + this.videoData.id;
        },
        ...GlobalComputed,
    },
    watch: {

    },
    methods: {
        ...GlobalMethods,
        loadMore(page){
            this.$emit('loadMore', page);
        },
        sync(data){
            Object.assign(this.videoData, data);
        },
        reloadVideoMeta(){
            if (!this.reloadingMeta){
                this.reloadingMeta = true;

                this.$store.dispatch('fastGetAction', {url: `/videos/${this.id}/meta`}).then(response=>{
                    this.reloadingMeta = false;
                    Object.assign(this.metaData, response.data);
                }).catch(e=>{
                    this.reloadingMeta = false;
                });
            }
        },
    },
    created(){
        this.videoData = this.video.data;
        this.metaData = this.meta;
        this.lectureData = this.lecture.data;
    },
    mounted(){
        if (!this.interval){
            this.interval = window.setInterval(()=>{
                this.reloadVideoMeta();
            }, 8000);
        }
    },
    beforeDestroy(){
        if (this.interval){
            window.clearInterval(this.interval);
        }
    }
}

</script>
